import { createFileRoute } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { CompanyNetworkTab } from '../../../-components/CompanyNetworkTab';
import { adminCompanyNetworkQueryOptions } from '../../../-hooks/useAdminCompanyNetwork';
import { DEFAULT_PAGE_SIZE } from '../../../-utils/pagination';

export const Route = createFileRoute(
  '/management/companies/(pages)/$companyId/network/',
)({
  // A removed company's network is a different endpoint, so the flag has to
  // reach the loader as well as the component.
  loaderDeps: ({ search }) => ({ isRemoved: search.isRemoved ?? false }),
  loader: ({ params, deps }) =>
    queryClient
      .ensureQueryData(
        adminCompanyNetworkQueryOptions({
          companyId: params.companyId,
          isRemoved: deps.isRemoved,
          page: 1,
          limit: DEFAULT_PAGE_SIZE,
        }),
      )
      // A failed prefetch must not blank the tab — the component's own query
      // re-runs and surfaces the error inline.
      .catch(() => undefined),
  component: CompanyNetworkPage,
});

function CompanyNetworkPage() {
  const { companyId } = Route.useParams();
  const { isRemoved } = Route.useSearch();
  return <CompanyNetworkTab companyId={companyId} isRemoved={isRemoved} />;
}
